import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Opens Bootstrap modals in the admin area (e.g. new book form).
export default class extends Controller {
  static targets = ["dialog"]
  static values = { open: { type: Boolean, default: false } }

  connect() {
    this.modal = Modal.getOrCreateInstance(this.dialogTarget)
    if (this.openValue) {
      this.modal.show()
    }
  }

  disconnect() {
    this.modal?.dispose()
    this.modal = null
  }

  open() {
    this.modal?.show()
  }

  close() {
    this.modal?.hide()
  }
}
